export enum ActFinishType {
    //Согласовать
    Approve = 0,
    //Согласовать с замечаниями
    Rework = 1,
    //Отклонить
    Refuse = 2,
}
